import i from "react";
import e from "prop-types";
import { d as l } from "../deprecate-Dt6BL0Y6.es.js";
import a from "../BaseToggle/index.es.js";
import { I as o } from "../Icon-BuIPTPJn.es.js";
import { w as n } from "../withTheme-zx3wTAWo.es.js";
import '../index4.css';const c = "#fff", h = "#ccc", p = "#939393", d = "IconToggle-module__icon___Xsj3U", t = {
  White: c,
  lightGray: h,
  medGray: p,
  icon: d
};
class s extends i.Component {
  constructor(r) {
    super(r), this.state = { inactiveColor: t.lightGray };
  }
  handleFocus = () => {
    this.setState({ inactiveColor: t.medGray });
  };
  handleReset = () => {
    this.setState({ inactiveColor: t.lightGray });
  };
  render() {
    return /* @__PURE__ */ i.createElement(
      a,
      {
        ...this.props,
        leftValue: this.props.left.value,
        rightValue: this.props.right.value,
        leftTitle: this.props.left.title,
        rightTitle: this.props.right.title,
        focus: this.handleFocus,
        reset: this.handleReset,
        icon: !0
      },
      /* @__PURE__ */ i.createElement("div", null, /* @__PURE__ */ i.createElement(
        o,
        {
          className: t.icon,
          name: this.props.left.icon,
          color: this.props.selectedValue === this.props.left.value ? t.White : this.state.inactiveColor
        }
      )),
      /* @__PURE__ */ i.createElement("div", null, /* @__PURE__ */ i.createElement(
        o,
        {
          className: t.icon,
          name: this.props.right.icon,
          color: this.props.selectedValue === this.props.right.value ? t.White : this.state.inactiveColor
        }
      ))
    );
  }
}
s.propTypes = {
  /** the object representing the left side of the toggle. */
  left: e.shape({
    /** the name of the svg icon to be displayed (see Icon stories) */
    icon: e.string.isRequired,
    /** the value that will be passed through the onToggle function */
    value: e.string.isRequired,
    /** the text that will appear when you hover over the icon. This is for when you want to give more information about the toggle. */
    title: e.string
  }).isRequired,
  /** the object representing the right side of the toggle. */
  right: e.shape({
    /** the name of the svg icon to be displayed (see Icon stories) */
    icon: e.string.isRequired,
    /** the value that will be passed through the onToggle function */
    value: e.string.isRequired,
    /** the text that will appear when you hover over the icon. This is for when you want to give more information about the toggle. */
    title: e.string
  }).isRequired,
  /** This should be the same value as either `left.value` or `right.value`, whichever you want selected by default */
  selectedValue: e.string,
  /* This is the function called on toggle, it will pass the value of whichever side is selected, either `left.value` or `right.value` */
  onToggle: e.func.isRequired,
  /** if true, the toggle cannot be toggled */
  disabled: e.bool,
  /** the MinDS theme of the toggle */
  theme: e.string,
  /** The color of the selected option. Available options are 'red', 'gray', 'blue', 'green' 'purple' and 'lavender' for default theme, and 'blue', 'green', 'purple' and 'pink' for compere theme. If none given or incorrect theme/color combination, the toggle color will default to a light gray */
  color: e.string
};
s.defaultProps = {
  selectedValue: null,
  disabled: !1,
  theme: "default",
  color: null
};
const u = l(
  "IconToggle is deprecated. Use Toggle instead"
)(s), q = n(u);
export {
  q as default
};
